import React from 'react';

import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';

const NotFound = () => {
  return (
    <div>
      <CssBaseline />
      <Container component="main" maxWidth="sm">
        <Typography variant="h1" component="h1" gutterBottom align="center">
          Page not found
        </Typography>
        <Typography variant="h5" component="h2" align="center">
          The requested page could not be found.
        </Typography>
      </Container>
    </div>
  );
};

export default NotFound;
